import type { ReactNode } from "react";

/**
 * A dashboard card: each of the overview's panels floats as its own island, so
 * the page reads as a handful of objects at a glance rather than one long sheet.
 *
 * It borrows the nav rail's float — `--radius-panel` and `--shadow-float` — rather
 * than inventing a second elevation (`styles/tokens.css`). The overview is the one
 * page that takes it; tables and detail views stay ruled paper.
 */
export function Card({
  children,
  className = "",
}: { readonly children: ReactNode; readonly className?: string }) {
  return (
    <div
      className={`rounded-panel border border-rule bg-paper-raised p-5 shadow-float md:p-6 ${className}`}
    >
      {children}
    </div>
  );
}
